
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { ValidationProvider } from "vee-validate";
import FormGroup from "@/components/form/FormGroupNew.vue";
import FormInputGroup from "@/components/form/FormInputGroupNew.vue";
import FormSelect from "@/components/form/FormSelectNew.vue";
import FormTextarea from "@/components/form/FormTextarea.vue";
import _ from "lodash";

@Component({
  components: {
    ValidationProvider,
    FormGroup,
    FormInputGroup,
    FormSelect,
    FormTextarea,
  },
})
export default class FunctionalAssessment extends Vue {
  @Prop({ required: true }) readonly formData!: Record<string, any>;

  localFormData: Record<string, any> = {};

  @Watch("formData", { immediate: true, deep: true })
  onFormDataChange(newVal: Record<string, any>) {
    this.localFormData = _.cloneDeep(newVal);
  }

  updateField(field: string, value: any) {
    this.localFormData[field] = value;
    this.$emit("update:formData", this.localFormData);
  }
}
